// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_vue_runtime-dom_dist_runtime-dom_esm-bundler_js-node_modules_jsqr_dist_j-a505b4"], () => (__webpack_require__("./index-vue.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
